<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.investor_edit' | translate }}</h3>

 <form #editForm="ngForm" (ngSubmit)="updateProduct()" enctype="multipart/form-data">
  <div class="row">
    <!-- Name (Arabic) -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">
          {{ 'MENU.DASHBOARD.name_ar' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_name_ar' | translate }}"
          [(ngModel)]="product.name_ar"
          name="name_ar"
          required
          #nameAr="ngModel"
        />
        <!-- Validation Message -->
        <div *ngIf="nameAr.invalid && nameAr.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.name_ar_required' | translate }}
        </div>
      </div>
    </div>

    <!-- Name (English) -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">
          {{ 'MENU.DASHBOARD.name_en' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_name_en' | translate }}"
          [(ngModel)]="product.name_en"
          name="name_en"
          required
          #nameEn="ngModel"
        />
        <!-- Validation Message -->
        <div *ngIf="nameEn.invalid && nameEn.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.name_en_required' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Submit Button -->
  <div class="text-start mt-3">
    <button
      type="submit"
      class="btn"
      style="background-color: #cca44c !important; color: #fff;"
      [disabled]="editForm.invalid"
    >
      {{ 'MENU.DASHBOARD.save_changes' | translate }}
    </button>
  </div>
</form>

  </div>
</div>
